/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  query CustomerReadQuery($customerId: ID!) {
    CustomerRead(customerId: $customerId, returnDeliveriesOfTrunk: false) {
      id,
      overDraftLimit,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
